import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from 'prop-types';
import React from 'react';
import BlockRadioButtons from '../../components/BlockRadioButtons';
import FormBox from '../../components/Form/FormBox';
import InfoBox from '../../components/InfoBox';
import InputField from '../../components/InputField';
import PageTitle from '../../components/PageTitle';
import SelectField from '../../components/SelectField/SelectField';
import FormHOC from '../../features/HOC/FormHOC';

const APRIL_2020_RELEASE_TIME = '1587116425991';

function SwapDetails(props) {
  const {
    application,
    approvalStatus1,
    approvalStatus2,
    dates,
    index,
    isTriangle,
    showDetails2,
    submitForm,
    swapAddress,
    currentApplicant,
    ...rest
  } = props;

  const { createdDate } = application;

  const shouldGetNewResidentsFormat = createdDate > APRIL_2020_RELEASE_TIME;

  function getName(member) {
    return (
      currentApplicant.members[`member${member}`].name || `Bytespart ${member}`
    );
  }

  function getForm(i) {
    const numberOfMembers = Object.values(
      currentApplicant.members
    ).filter((m) => Boolean(m)).length;
    let swapTitle = 'du';
    if (showDetails2) swapTitle = getName(i);
    else if (numberOfMembers > 1 || isTriangle) swapTitle = 'ni';

    const form = [
      {
        component: swapAddress.length === 1 ? InputField : SelectField,
        title: `Adress som ${swapTitle} ska flytta till`,
        key: `details${i}`,
        id: `moveToApartment${i}`,
        placeholder: 'Adress',
        description:
          'Ange den adress som denna part kommer flytta till i det i detta byte',
        option: swapAddress,
        disabled: swapAddress.length === 1,
      },
      {
        title: shouldGetNewResidentsFormat
          ? 'Antal vuxna i hushållet'
          : 'Antal personer i hushållet',
        key: `details${i}`,
        id: `personCount${i}`,
        type: 'number',
        placeholder: shouldGetNewResidentsFormat
          ? 'Antal vuxna i hushållet'
          : 'Antal personer i hushållet',
        description: shouldGetNewResidentsFormat
          ? 'Ange antal vuxna som ska bo i hushållet (personer som är över 18)'
          : 'Ange antal personer i hushållet totalt',
      },
      {
        title: shouldGetNewResidentsFormat
          ? 'Antal barn i hushållet'
          : 'Varav barn',
        key: `details${i}`,
        id: `childrenCount${i}`,
        type: 'number',
        placeholder: shouldGetNewResidentsFormat
          ? 'Antal barn i hushållet'
          : 'Varav barn',
        description: shouldGetNewResidentsFormat
          ? 'Fyll i antal barn som ska bo i hushållet (personer som är under 18)'
          : 'Fyll i hur många av personerna i hushållet som är under 18',
      },
    ];

    const swapDates = {
      component: BlockRadioButtons,
      title: 'Bytesdatum',
      name: 'swapDate',
      description:
        'Prata ihop dig med de andra parterna om vilket bytesdatum ni föredrar och välj det här. Tänk på att du som huvudregel behöver ha bott i lägenheten i minst 1 år för att få byta enligt den nya hyreslagen.',
      id: 'swapDate',
      options: getDates(),
    };

    if (!showDetails2) form.push(swapDates);
    else if (i === 2) form.push(swapDates);
    return form;
  }
  return (
    <React.Fragment>
      <PageTitle>Detaljer kring bytet</PageTitle>
      <FormBox
        form={getForm(1)}
        handleClick={(e) => submitForm(e, index)}
        renderSaveButton={!showDetails2}
        status={approvalStatus1}
        {...rest}
      />

      {showDetails2 && (
        <FormBox
          form={getForm(2)}
          handleClick={(e) => submitForm(e, index)}
          status={approvalStatus2}
          {...rest}
        />
      )}
      <InfoBox header="Tänk på att">
        <p>
          Då byten i regel sker vid månadsskiften så är det endast möjligt att
          välja den första varje månad som önskat bytesdatum. Ett byte tar i
          snitt 6-8 veckor så det är därför inte möjligt att välja ett
          månadsskifte som inte ligger inom ramen för detta.
        </p>
        <p>
          Exempel: Anmälning till Bytesansökan sker 5/1 och önskemålet är att
          flytta så snart som möjligt. Önskat bytesdatum på ansökningarna blir
          då 1/3.
        </p>
        <p>OBS! Detta är ett önskemål på inflyttningsdatum.</p>
      </InfoBox>
    </React.Fragment>
  );
}

SwapDetails.propTypes = {
  approvalStatus1: shape({
    type: string,
  }),
  approvalStatus2: shape({
    type: string,
  }),
  dates: arrayOf(
    shape({
      id: string,
      label: string,
    })
  ),
  index: oneOfType([number, string]).isRequired,
  isTriangle: bool,
  showDetails2: bool,
  submitForm: func.isRequired,
  swapAddress: arrayOf(
    shape({
      address: string,
    })
  ).isRequired,
  currentApplicant: shape({
    index: number,
  }).isRequired,
};

SwapDetails.defaultProps = {
  approvalStatus1: {
    type: '',
  },
  approvalStatus2: {
    type: '',
  },
  isTriangle: false,
  showDetails2: false,
  dates: [],
};

export default FormHOC(SwapDetails, {
  state: (state) => ({
    isTriangle: state.application.isTriangle,
    showDetails2: state.application.showDetails2,
  }),
  form: 'details',
  field: 'details',
});

function getDates() {
  const months = [];
  const formatter = new Intl.DateTimeFormat('sv', {
    month: 'long',
  });
  for (let i = 2; i < 6; i += 1) {
    const start = new Date();
    start.setDate(1);
    start.setMonth(start.getMonth() + i);
    const month = formatter.format(start);
    months.push({
      id: month,
      label: `1:a ${month.substring(0, 3)}`,
    });
  }

  return months;
}



// WEBPACK FOOTER //
// ./src/views/SwapDetails/index.js